<template>
  <div
    class="mb-5 border-b border-gray-200 px-4 pb-5 sm:flex sm:justify-between"
  >
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      {{ label }}
    </h3>
    <div class="flex items-center">
      <slot name="actions">
        <div class="mx-2 mt-3 sm:mt-0 sm:ml-4">
          <SectionHeadingButton
            v-if="link"
            label="Nieuw"
            :link="route(link)"
          ></SectionHeadingButton>
        </div>
      </slot>
      <slot name="after-actions"></slot>
    </div>
  </div>
</template>

<script>
import SectionHeadingButton from '@common/SectionHeadingButton'
export default {
  name: 'SectionHeading',
  components: { SectionHeadingButton },
  props: {
    label: {
      type: String,
    },
    link: {
      type: String,
    },
  },
}
</script>

<style scoped></style>
